import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import { useDispatch } from 'react-redux';
import { setConferenceAction } from 'store/conference/conferenceActions';
import { addVideoToConference, getBroadcastPresignedS3Url } from 'utils/apiCalls';
import logger from 'logger';
import PropTypes from 'prop-types';
import LoadingSpinner from 'components/LoadingSpinner';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '8rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '1rem',
    border: '2px dashed',
    borderColor: theme.palette.primary.main,
    fontWeight: 'bold',
    cursor: 'pointer',
  },
}));

const FileUpload = ({ SessionId }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isUploading, setIsUploading] = useState(false);

  const handleSubmit = async (files) => {
    try {
      files.map(async (file) => {
        setIsUploading(true);
        const s3url = await getBroadcastPresignedS3Url(
          `${SessionId}/mp4s/${file.name}`,
          file.type,
          'putObject'
        );
        const config = {
          headers: {
            'Content-Type': file.type,
          },
        };

        const results = await axios.put(s3url.data, file, config);
        if (results.status === 200) {
          const newConferenceData = await addVideoToConference(SessionId, {
            Name: file.name,
            Key: `${SessionId}/mp4s/${file.name}`,
          });

          dispatch(setConferenceAction(newConferenceData.data));
        }
        setIsUploading(false);
      });
    } catch (e) {
      logger.error('FileUpload', { e });
      setIsUploading(false);
    }
  };

  if (isUploading) return <LoadingSpinner />;

  return (
    <Dropzone accept=".mp4" onDrop={(acceptedFiles) => handleSubmit(acceptedFiles)}>
      {({ getRootProps, getInputProps, isDragActive }) => (
        <div {...getRootProps()} className={classes.root}>
          <input {...getInputProps()} />
          {isDragActive ? 'Drop the file!' : 'Click me or drag a file to upload!'}
        </div>
      )}
    </Dropzone>
  );
};

FileUpload.propTypes = {
  SessionId: PropTypes.string,
};

export default FileUpload;
